import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import './Updates.css';

const Updates_3_38_0 = () => {
  return (
    <div>
      <PageTitle title='3.38.0' />

      <ParaTitle paraTitle='Question Set, Bug Fixes, & Optimization' />
      <Paragraph paragraph='2025-02-10' />

      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>Added "Workplace Violence" category
          <p>Updated the Healthcare Event Reporting Form by adding a "Workplace Violence" category to Question DE21.</p>
        </li>
        <li>Admin user management page optimization
          <p>Optimized page performance by reducing excessive data retrieval. Implemented pagination and limited data fetching to only what is necessary for displaying the table.</p>
        </li>
        <li>Updated tutorial link in login page
        </li>
        <li>Enhanced Google Analytics
        </li>
      </ul>

      <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>
            Duplicate entries for feedback report bug
          <p>Removed duplicate entries in the report that differed only by a space or comma, counting them as a single choice instead of two distinct ones.</p>
        </li>
      </ul>

      <Pagination
                pagination={{
                    prev: { name: 'Updates: 3.40.0', link: '/updates/3.40.0' },
                    next: { name: 'Events Summary', link: '/general/events-summary' }
                }}
            />
    </div>

  )
}

export default Updates_3_38_0;